module.exports = __webpack_public_path__ + "static/media/86719B15-14C3-4F08-9CB3-28562D872B2B.849664f2.JPG";